export const CONSUMPTION_POINTS_FETCH =
  'CANCELING_CERTIFICATE_CONSUMPTION_POINTS_FETCH';
export const CONSUMPTION_POINTS_FOR_EECS_FETCH =
  'CANCELING_CERTIFICATE_CONSUMPTION_POINTS_FOR_EECS_FETCH';
export const GO_AMOUNT_FETCH = 'CANCELING_CERTIFICATE_GO_AMOUNT_FETCH';
export const CANCEL_CERTIFICATES = 'CANCELING_CERTIFICATE_CANCEL_CERTIFICATES';
export const CANCEL_CERTIFICATES_FOR_EECS =
  'CANCELING_CERTIFICATE_CANCEL_CERTIFICATES_FOR_EECS';
